import { css } from '@emotion/core';

export const arrow = css`
  content: '';
  width: 0.6em;
  height: 0.6em;
  margin-left: 1em;
  position: absolute;
  border-left: 1px solid black;
  border-bottom: 1px solid black;
  cursor: pointer;
`;

const arrowCont = css`
  position: relative;
  ::after {
    ${arrow};
  }
`;

export const arrowUp = css`
  ${arrowCont};
  ::after {
    transform: rotate(135deg);
    top: 35%;
  }
`;
export const arrowDown = css`
  ${arrowCont};
  ::after {
    transform: rotate(-45deg);
    top: 19%;
  }
`;
